import { WorkflowEngineMode } from './workflowEngineReducer';
import entryConfig from '../FormEngine/Entry';
import builderConfig from '../FormEngine/Builder';
import previewConfig from '../FormEngine/Preview';
import mapperConfig from '../FormEngine/Mapper';

export interface WorkflowEngineConfig {
  container: JSX.Element;
  loadingView: JSX.Element;
}

const workflowEngineDictionary: Record<
  WorkflowEngineMode,
  WorkflowEngineConfig
> = {
  [WorkflowEngineMode.ENTRY]: entryConfig,
  [WorkflowEngineMode.PREVIEW]: previewConfig,
  [WorkflowEngineMode.BUILD]: builderConfig,
  [WorkflowEngineMode.MAPPER]: mapperConfig
};

export default workflowEngineDictionary;
